import getSymbolFromCurrency from 'currency-symbol-map'

export enum JobPostingCurrencyOption {
    AED = 'AED',
    AFN = 'AFN',
    ALL = 'ALL',
    AMD = 'AMD',
    ANG = 'ANG',
    AOA = 'AOA',
    ARS = 'ARS',
    AUD = 'AUD',
    AWG = 'AWG',
    AZN = 'AZN',
    BAM = 'BAM',
    BBD = 'BBD',
    BDT = 'BDT',
    BGN = 'BGN',
    BHD = 'BHD',
    BIF = 'BIF',
    BMD = 'BMD',
    BND = 'BND',
    BOB = 'BOB',
    BOV = 'BOV',
    BRL = 'BRL',
    BSD = 'BSD',
    BTC = 'BTC',
    BTN = 'BTN',
    BWP = 'BWP',
    BYN = 'BYN',
    BYR = 'BYR',
    BZD = 'BZD',
    CAD = 'CAD',
    CDF = 'CDF',
    CHE = 'CHE',
    CHF = 'CHF',
    CHW = 'CHW',
    CLF = 'CLF',
    CLP = 'CLP',
    CNH = 'CNH',
    CNY = 'CNY',
    COP = 'COP',
    COU = 'COU',
    CRC = 'CRC',
    CUC = 'CUC',
    CUP = 'CUP',
    CVE = 'CVE',
    CZK = 'CZK',
    DJF = 'DJF',
    DKK = 'DKK',
    DOP = 'DOP',
    DZD = 'DZD',
    EEK = 'EEK',
    EGP = 'EGP',
    ERN = 'ERN',
    ETB = 'ETB',
    ETH = 'ETH',
    EUR = 'EUR',
    FJD = 'FJD',
    FKP = 'FKP',
    GBP = 'GBP',
    GEL = 'GEL',
    GGP = 'GGP',
    GHC = 'GHC',
    GHS = 'GHS',
    GIP = 'GIP',
    GMD = 'GMD',
    GNF = 'GNF',
    GTQ = 'GTQ',
    GYD = 'GYD',
    HKD = 'HKD',
    HNL = 'HNL',
    HRK = 'HRK',
    HTG = 'HTG',
    HUF = 'HUF',
    IDR = 'IDR',
    ILS = 'ILS',
    IMP = 'IMP',
    INR = 'INR',
    IQD = 'IQD',
    IRR = 'IRR',
    ISK = 'ISK',
    JEP = 'JEP',
    JMD = 'JMD',
    JOD = 'JOD',
    JPY = 'JPY',
    KES = 'KES',
    KGS = 'KGS',
    KHR = 'KHR',
    KMF = 'KMF',
    KPW = 'KPW',
    KRW = 'KRW',
    KWD = 'KWD',
    KYD = 'KYD',
    KZT = 'KZT',
    LAK = 'LAK',
    LBP = 'LBP',
    LKR = 'LKR',
    LRD = 'LRD',
    LSL = 'LSL',
    LTC = 'LTC',
    LTL = 'LTL',
    LVL = 'LVL',
    LYD = 'LYD',
    MAD = 'MAD',
    MDL = 'MDL',
    MGA = 'MGA',
    MKD = 'MKD',
    MMK = 'MMK',
    MNT = 'MNT',
    MOP = 'MOP',
    MRO = 'MRO',
    MRU = 'MRU',
    MUR = 'MUR',
    MVR = 'MVR',
    MWK = 'MWK',
    MXN = 'MXN',
    MXV = 'MXV',
    MYR = 'MYR',
    MZN = 'MZN',
    NAD = 'NAD',
    NGN = 'NGN',
    NIO = 'NIO',
    NOK = 'NOK',
    NPR = 'NPR',
    NZD = 'NZD',
    OMR = 'OMR',
    PAB = 'PAB',
    PEN = 'PEN',
    PGK = 'PGK',
    PHP = 'PHP',
    PKR = 'PKR',
    PLN = 'PLN',
    PYG = 'PYG',
    QAR = 'QAR',
    RMB = 'RMB',
    RON = 'RON',
    RSD = 'RSD',
    RUB = 'RUB',
    RWF = 'RWF',
    SAR = 'SAR',
    SBD = 'SBD',
    SCR = 'SCR',
    SDG = 'SDG',
    SEK = 'SEK',
    SGD = 'SGD',
    SHP = 'SHP',
    SLL = 'SLL',
    SOS = 'SOS',
    SRD = 'SRD',
    SSP = 'SSP',
    STD = 'STD',
    STN = 'STN',
    SVC = 'SVC',
    SYP = 'SYP',
    SZL = 'SZL',
    THB = 'THB',
    TJS = 'TJS',
    TMT = 'TMT',
    TND = 'TND',
    TOP = 'TOP',
    TRL = 'TRL',
    TRY = 'TRY',
    TTD = 'TTD',
    TVD = 'TVD',
    TWD = 'TWD',
    TZS = 'TZS',
    UAH = 'UAH',
    UGX = 'UGX',
    USD = 'USD',
    UYI = 'UYI',
    UYU = 'UYU',
    UYW = 'UYW',
    UZS = 'UZS',
    VEF = 'VEF',
    VES = 'VES',
    VND = 'VND',
    VUV = 'VUV',
    WST = 'WST',
    XAF = 'XAF',
    XBT = 'XBT',
    XCD = 'XCD',
    XOF = 'XOF',
    XPF = 'XPF',
    XSU = 'XSU',
    XUA = 'XUA',
    YER = 'YER',
    ZAR = 'ZAR',
    ZMW = 'ZMW',
    ZWD = 'ZWD',
    ZWL = 'ZWL',
}

export enum JobPostingCountryOption {
    Singapore = 'Singapore',
    India = 'India',
    United_States = 'United_States',
    United_Kingdom = 'United_Kingdom',
    United_Arab_Emirates = 'United_Arab_Emirates',
    Malaysia = 'Malaysia',
    Thailand = 'Thailand',
    Andorra = 'Andorra',
    Afghanistan = 'Afghanistan',
    Antigua_Barbuda = 'Antigua_Barbuda',
    Anguilla = 'Anguilla',
    Albania = 'Albania',
    Armenia = 'Armenia',
    Angola = 'Angola',
    Antarctica = 'Antarctica',
    Argentina = 'Argentina',
    American_Samoa = 'American_Samoa',
    Austria = 'Austria',
    Australia = 'Australia',
    Aruba = 'Aruba',
    land_Islands = 'land_Islands',
    Azerbaijan = 'Azerbaijan',
    Bosnia_Herzegovina = 'Bosnia_Herzegovina',
    Barbados = 'Barbados',
    Bangladesh = 'Bangladesh',
    Belgium = 'Belgium',
    Burkina_Faso = 'Burkina_Faso',
    Bulgaria = 'Bulgaria',
    Bahrain = 'Bahrain',
    Burundi = 'Burundi',
    Benin = 'Benin',
    St_Barthlemy = 'St_Barthlemy',
    Bermuda = 'Bermuda',
    Brunei = 'Brunei',
    Bolivia = 'Bolivia',
    Caribbean_Netherlands = 'Caribbean_Netherlands',
    Brazil = 'Brazil',
    Bahamas = 'Bahamas',
    Bhutan = 'Bhutan',
    Bouvet_Island = 'Bouvet_Island',
    Botswana = 'Botswana',
    Belarus = 'Belarus',
    Belize = 'Belize',
    Canada = 'Canada',
    Cocos_Keeling_Islands = 'Cocos_Keeling_Islands',
    Congo_Kinshasa = 'Congo_Kinshasa',
    Central_African_Republic = 'Central_African_Republic',
    Congo_Brazzaville = 'Congo_Brazzaville',
    Switzerland = 'Switzerland',
    Cte_dIvoire = 'Cte_dIvoire',
    Cook_Islands = 'Cook_Islands',
    Chile = 'Chile',
    Cameroon = 'Cameroon',
    China = 'China',
    Colombia = 'Colombia',
    Costa_Rica = 'Costa_Rica',
    Cuba = 'Cuba',
    Cape_Verde = 'Cape_Verde',
    Curaao = 'Curaao',
    Christmas_Island = 'Christmas_Island',
    Cyprus = 'Cyprus',
    Czechia = 'Czechia',
    Germany = 'Germany',
    Djibouti = 'Djibouti',
    Denmark = 'Denmark',
    Dominica = 'Dominica',
    Dominican_Republic = 'Dominican_Republic',
    Algeria = 'Algeria',
    Ecuador = 'Ecuador',
    Estonia = 'Estonia',
    Egypt = 'Egypt',
    Western_Sahara = 'Western_Sahara',
    Eritrea = 'Eritrea',
    Spain = 'Spain',
    Ethiopia = 'Ethiopia',
    Finland = 'Finland',
    Fiji = 'Fiji',
    Falkland_Islands = 'Falkland_Islands',
    Micronesia = 'Micronesia',
    Faroe_Islands = 'Faroe_Islands',
    France = 'France',
    Gabon = 'Gabon',
    Grenada = 'Grenada',
    Georgia = 'Georgia',
    French_Guiana = 'French_Guiana',
    Guernsey = 'Guernsey',
    Ghana = 'Ghana',
    Gibraltar = 'Gibraltar',
    Greenland = 'Greenland',
    Gambia = 'Gambia',
    Guinea = 'Guinea',
    Guadeloupe = 'Guadeloupe',
    Equatorial_Guinea = 'Equatorial_Guinea',
    Greece = 'Greece',
    South_Georgia_South_Sandwich_Islands = 'South_Georgia_South_Sandwich_Islands',
    Guatemala = 'Guatemala',
    Guam = 'Guam',
    GuineaBissau = 'GuineaBissau',
    Guyana = 'Guyana',
    Hong_Kong_SAR_China = 'Hong_Kong_SAR_China',
    Heard_McDonald_Islands = 'Heard_McDonald_Islands',
    Honduras = 'Honduras',
    Croatia = 'Croatia',
    Haiti = 'Haiti',
    Hungary = 'Hungary',
    Indonesia = 'Indonesia',
    Ireland = 'Ireland',
    Israel = 'Israel',
    Isle_of_Man = 'Isle_of_Man',
    British_Indian_Ocean_Territory = 'British_Indian_Ocean_Territory',
    Iraq = 'Iraq',
    Iran = 'Iran',
    Iceland = 'Iceland',
    Italy = 'Italy',
    Jersey = 'Jersey',
    Jamaica = 'Jamaica',
    Jordan = 'Jordan',
    Japan = 'Japan',
    Kenya = 'Kenya',
    Kyrgyzstan = 'Kyrgyzstan',
    Cambodia = 'Cambodia',
    Kiribati = 'Kiribati',
    Comoros = 'Comoros',
    St_Kitts_Nevis = 'St_Kitts_Nevis',
    North_Korea = 'North_Korea',
    South_Korea = 'South_Korea',
    Kuwait = 'Kuwait',
    Cayman_Islands = 'Cayman_Islands',
    Kazakhstan = 'Kazakhstan',
    Laos = 'Laos',
    Lebanon = 'Lebanon',
    St_Lucia = 'St_Lucia',
    Liechtenstein = 'Liechtenstein',
    Sri_Lanka = 'Sri_Lanka',
    Liberia = 'Liberia',
    Lesotho = 'Lesotho',
    Lithuania = 'Lithuania',
    Luxembourg = 'Luxembourg',
    Latvia = 'Latvia',
    Libya = 'Libya',
    Morocco = 'Morocco',
    Monaco = 'Monaco',
    Moldova = 'Moldova',
    Montenegro = 'Montenegro',
    St_Martin = 'St_Martin',
    Madagascar = 'Madagascar',
    Marshall_Islands = 'Marshall_Islands',
    North_Macedonia = 'North_Macedonia',
    Mali = 'Mali',
    Myanmar_Burma = 'Myanmar_Burma',
    Mongolia = 'Mongolia',
    Macao_SAR_China = 'Macao_SAR_China',
    Northern_Mariana_Islands = 'Northern_Mariana_Islands',
    Martinique = 'Martinique',
    Mauritania = 'Mauritania',
    Montserrat = 'Montserrat',
    Malta = 'Malta',
    Mauritius = 'Mauritius',
    Maldives = 'Maldives',
    Malawi = 'Malawi',
    Mexico = 'Mexico',
    Mozambique = 'Mozambique',
    Namibia = 'Namibia',
    New_Caledonia = 'New_Caledonia',
    Niger = 'Niger',
    Norfolk_Island = 'Norfolk_Island',
    Nigeria = 'Nigeria',
    Nicaragua = 'Nicaragua',
    Netherlands = 'Netherlands',
    Norway = 'Norway',
    Nepal = 'Nepal',
    Nauru = 'Nauru',
    Niue = 'Niue',
    New_Zealand = 'New_Zealand',
    Oman = 'Oman',
    Panama = 'Panama',
    Peru = 'Peru',
    French_Polynesia = 'French_Polynesia',
    Papua_New_Guinea = 'Papua_New_Guinea',
    Philippines = 'Philippines',
    Pakistan = 'Pakistan',
    Poland = 'Poland',
    St_Pierre_Miquelon = 'St_Pierre_Miquelon',
    Pitcairn_Islands = 'Pitcairn_Islands',
    Puerto_Rico = 'Puerto_Rico',
    Palestinian_Territories = 'Palestinian_Territories',
    Portugal = 'Portugal',
    Palau = 'Palau',
    Paraguay = 'Paraguay',
    Qatar = 'Qatar',
    Runion = 'Runion',
    Romania = 'Romania',
    Serbia = 'Serbia',
    Russia = 'Russia',
    Rwanda = 'Rwanda',
    Saudi_Arabia = 'Saudi_Arabia',
    Solomon_Islands = 'Solomon_Islands',
    Seychelles = 'Seychelles',
    Sudan = 'Sudan',
    Sweden = 'Sweden',
    St_Helena = 'St_Helena',
    Slovenia = 'Slovenia',
    Svalbard_Jan_Mayen = 'Svalbard_Jan_Mayen',
    Slovakia = 'Slovakia',
    Sierra_Leone = 'Sierra_Leone',
    San_Marino = 'San_Marino',
    Senegal = 'Senegal',
    Somalia = 'Somalia',
    Suriname = 'Suriname',
    South_Sudan = 'South_Sudan',
    So_Tom_Prncipe = 'So_Tom_Prncipe',
    El_Salvador = 'El_Salvador',
    Sint_Maarten = 'Sint_Maarten',
    Syria = 'Syria',
    Eswatini = 'Eswatini',
    Turks_Caicos_Islands = 'Turks_Caicos_Islands',
    Chad = 'Chad',
    French_Southern_Territories = 'French_Southern_Territories',
    Togo = 'Togo',
    Tajikistan = 'Tajikistan',
    Tokelau = 'Tokelau',
    TimorLeste = 'TimorLeste',
    Turkmenistan = 'Turkmenistan',
    Tunisia = 'Tunisia',
    Tonga = 'Tonga',
    Trkiye = 'Trkiye',
    Trinidad_Tobago = 'Trinidad_Tobago',
    Tuvalu = 'Tuvalu',
    Taiwan = 'Taiwan',
    Tanzania = 'Tanzania',
    Ukraine = 'Ukraine',
    Uganda = 'Uganda',
    US_Outlying_Islands = 'US_Outlying_Islands',
    Uruguay = 'Uruguay',
    Uzbekistan = 'Uzbekistan',
    Vatican_City = 'Vatican_City',
    St_Vincent_Grenadines = 'St_Vincent_Grenadines',
    Venezuela = 'Venezuela',
    British_Virgin_Islands = 'British_Virgin_Islands',
    US_Virgin_Islands = 'US_Virgin_Islands',
    Vietnam = 'Vietnam',
    Vanuatu = 'Vanuatu',
    Wallis_Futuna = 'Wallis_Futuna',
    Samoa = 'Samoa',
    Yemen = 'Yemen',
    Mayotte = 'Mayotte',
    South_Africa = 'South_Africa',
    Zambia = 'Zambia',
    Zimbabwe = 'Zimbabwe',
}

export const JOB_POSTING_CURRENCY_MAPPING: { label: string; value: JobPostingCurrencyOption; symbol: string | undefined }[] = [
    { label: 'United Arab Emirates Dirham', value: JobPostingCurrencyOption.AED, symbol: 'د.إ' },
    { label: 'Afghan Afghani', value: JobPostingCurrencyOption.AFN, symbol: '؋' },
    { label: 'Albanian Lek', value: JobPostingCurrencyOption.ALL, symbol: 'L' },
    { label: 'Armenian Dram', value: JobPostingCurrencyOption.AMD, symbol: '֏' },
    { label: 'Netherlands Antillean Guilder', value: JobPostingCurrencyOption.ANG, symbol: 'ƒ' },
    { label: 'Angolan Kwanza', value: JobPostingCurrencyOption.AOA, symbol: 'Kz' },
    { label: 'Argentine Peso', value: JobPostingCurrencyOption.ARS, symbol: '$' },
    { label: 'Australian Dollar', value: JobPostingCurrencyOption.AUD, symbol: '$' },
    { label: 'Aruban Florin', value: JobPostingCurrencyOption.AWG, symbol: 'ƒ' },
    { label: 'Azerbaijani Manat', value: JobPostingCurrencyOption.AZN, symbol: '₼' },
    { label: 'Bosnia-Herzegovina Convertible Mark', value: JobPostingCurrencyOption.BAM, symbol: 'KM' },
    { label: 'Barbadian Dollar', value: JobPostingCurrencyOption.BBD, symbol: '$' },
    { label: 'Bangladeshi Taka', value: JobPostingCurrencyOption.BDT, symbol: '৳' },
    { label: 'Bulgarian Lev', value: JobPostingCurrencyOption.BGN, symbol: 'лв' },
    { label: 'Bahraini Dinar', value: JobPostingCurrencyOption.BHD, symbol: '.د.ب' },
    { label: 'Burundian Franc', value: JobPostingCurrencyOption.BIF, symbol: 'FBu' },
    { label: 'Bermudan Dollar', value: JobPostingCurrencyOption.BMD, symbol: '$' },
    { label: 'Brunei Dollar', value: JobPostingCurrencyOption.BND, symbol: '$' },
    { label: 'Bolivian Boliviano', value: JobPostingCurrencyOption.BOB, symbol: '$b' },
    { label: 'Bolivian Mvdol', value: JobPostingCurrencyOption.BOV, symbol: 'BOV' },
    { label: 'Brazilian Real', value: JobPostingCurrencyOption.BRL, symbol: 'R$' },
    { label: 'Bahamian Dollar', value: JobPostingCurrencyOption.BSD, symbol: '$' },
    { label: 'BTC', value: JobPostingCurrencyOption.BTC, symbol: '₿' },
    { label: 'Bhutanese Ngultrum', value: JobPostingCurrencyOption.BTN, symbol: 'Nu.' },
    { label: 'Botswanan Pula', value: JobPostingCurrencyOption.BWP, symbol: 'P' },
    { label: 'Belarusian Ruble', value: JobPostingCurrencyOption.BYN, symbol: 'Br' },
    { label: 'Belarusian Ruble (2000–2016)', value: JobPostingCurrencyOption.BYR, symbol: 'Br' },
    { label: 'Belize Dollar', value: JobPostingCurrencyOption.BZD, symbol: 'BZ$' },
    { label: 'Canadian Dollar', value: JobPostingCurrencyOption.CAD, symbol: '$' },
    { label: 'Congolese Franc', value: JobPostingCurrencyOption.CDF, symbol: 'FC' },
    { label: 'WIR Euro', value: JobPostingCurrencyOption.CHE, symbol: 'CHE' },
    { label: 'Swiss Franc', value: JobPostingCurrencyOption.CHF, symbol: 'CHF' },
    { label: 'WIR Franc', value: JobPostingCurrencyOption.CHW, symbol: 'CHW' },
    { label: 'Chilean Unit of Account (UF)', value: JobPostingCurrencyOption.CLF, symbol: 'CLF' },
    { label: 'Chilean Peso', value: JobPostingCurrencyOption.CLP, symbol: '$' },
    { label: 'Chinese Yuan (offshore)', value: JobPostingCurrencyOption.CNH, symbol: '¥' },
    { label: 'Chinese Yuan', value: JobPostingCurrencyOption.CNY, symbol: '¥' },
    { label: 'Colombian Peso', value: JobPostingCurrencyOption.COP, symbol: '$' },
    { label: 'Colombian Real Value Unit', value: JobPostingCurrencyOption.COU, symbol: 'COU' },
    { label: 'Costa Rican Colón', value: JobPostingCurrencyOption.CRC, symbol: '₡' },
    { label: 'Cuban Convertible Peso', value: JobPostingCurrencyOption.CUC, symbol: '$' },
    { label: 'Cuban Peso', value: JobPostingCurrencyOption.CUP, symbol: '₱' },
    { label: 'Cape Verdean Escudo', value: JobPostingCurrencyOption.CVE, symbol: '$' },
    { label: 'Czech Koruna', value: JobPostingCurrencyOption.CZK, symbol: 'Kč' },
    { label: 'Djiboutian Franc', value: JobPostingCurrencyOption.DJF, symbol: 'Fdj' },
    { label: 'Danish Krone', value: JobPostingCurrencyOption.DKK, symbol: 'kr' },
    { label: 'Dominican Peso', value: JobPostingCurrencyOption.DOP, symbol: 'RD$' },
    { label: 'Algerian Dinar', value: JobPostingCurrencyOption.DZD, symbol: 'دج' },
    { label: 'Estonian Kroon', value: JobPostingCurrencyOption.EEK, symbol: 'kr' },
    { label: 'Egyptian Pound', value: JobPostingCurrencyOption.EGP, symbol: '£' },
    { label: 'Eritrean Nakfa', value: JobPostingCurrencyOption.ERN, symbol: 'Nfk' },
    { label: 'Ethiopian Birr', value: JobPostingCurrencyOption.ETB, symbol: 'Br' },
    { label: 'ETH', value: JobPostingCurrencyOption.ETH, symbol: 'Ξ' },
    { label: 'Euro', value: JobPostingCurrencyOption.EUR, symbol: '€' },
    { label: 'Fijian Dollar', value: JobPostingCurrencyOption.FJD, symbol: '$' },
    { label: 'Falkland Islands Pound', value: JobPostingCurrencyOption.FKP, symbol: '£' },
    { label: 'British Pound', value: JobPostingCurrencyOption.GBP, symbol: '£' },
    { label: 'Georgian Lari', value: JobPostingCurrencyOption.GEL, symbol: '₾' },
    { label: 'GGP', value: JobPostingCurrencyOption.GGP, symbol: '£' },
    { label: 'Ghanaian Cedi (1979–2007)', value: JobPostingCurrencyOption.GHC, symbol: '₵' },
    { label: 'Ghanaian Cedi', value: JobPostingCurrencyOption.GHS, symbol: 'GH₵' },
    { label: 'Gibraltar Pound', value: JobPostingCurrencyOption.GIP, symbol: '£' },
    { label: 'Gambian Dalasi', value: JobPostingCurrencyOption.GMD, symbol: 'D' },
    { label: 'Guinean Franc', value: JobPostingCurrencyOption.GNF, symbol: 'FG' },
    { label: 'Guatemalan Quetzal', value: JobPostingCurrencyOption.GTQ, symbol: 'Q' },
    { label: 'Guyanaese Dollar', value: JobPostingCurrencyOption.GYD, symbol: '$' },
    { label: 'Hong Kong Dollar', value: JobPostingCurrencyOption.HKD, symbol: '$' },
    { label: 'Honduran Lempira', value: JobPostingCurrencyOption.HNL, symbol: 'L' },
    { label: 'Croatian Kuna', value: JobPostingCurrencyOption.HRK, symbol: 'kn' },
    { label: 'Haitian Gourde', value: JobPostingCurrencyOption.HTG, symbol: 'G' },
    { label: 'Hungarian Forint', value: JobPostingCurrencyOption.HUF, symbol: 'Ft' },
    { label: 'Indonesian Rupiah', value: JobPostingCurrencyOption.IDR, symbol: 'Rp' },
    { label: 'Israeli New Shekel', value: JobPostingCurrencyOption.ILS, symbol: '₪' },
    { label: 'IMP', value: JobPostingCurrencyOption.IMP, symbol: '£' },
    { label: 'Indian Rupee', value: JobPostingCurrencyOption.INR, symbol: '₹' },
    { label: 'Iraqi Dinar', value: JobPostingCurrencyOption.IQD, symbol: 'ع.د' },
    { label: 'Iranian Rial', value: JobPostingCurrencyOption.IRR, symbol: '﷼' },
    { label: 'Icelandic Króna', value: JobPostingCurrencyOption.ISK, symbol: 'kr' },
    { label: 'JEP', value: JobPostingCurrencyOption.JEP, symbol: '£' },
    { label: 'Jamaican Dollar', value: JobPostingCurrencyOption.JMD, symbol: 'J$' },
    { label: 'Jordanian Dinar', value: JobPostingCurrencyOption.JOD, symbol: 'JD' },
    { label: 'Japanese Yen', value: JobPostingCurrencyOption.JPY, symbol: '¥' },
    { label: 'Kenyan Shilling', value: JobPostingCurrencyOption.KES, symbol: 'KSh' },
    { label: 'Kyrgyz Som', value: JobPostingCurrencyOption.KGS, symbol: 'лв' },
    { label: 'Cambodian Riel', value: JobPostingCurrencyOption.KHR, symbol: '៛' },
    { label: 'Comorian Franc', value: JobPostingCurrencyOption.KMF, symbol: 'CF' },
    { label: 'North Korean Won', value: JobPostingCurrencyOption.KPW, symbol: '₩' },
    { label: 'South Korean Won', value: JobPostingCurrencyOption.KRW, symbol: '₩' },
    { label: 'Kuwaiti Dinar', value: JobPostingCurrencyOption.KWD, symbol: 'KD' },
    { label: 'Cayman Islands Dollar', value: JobPostingCurrencyOption.KYD, symbol: '$' },
    { label: 'Kazakhstani Tenge', value: JobPostingCurrencyOption.KZT, symbol: '₸' },
    { label: 'Laotian Kip', value: JobPostingCurrencyOption.LAK, symbol: '₭' },
    { label: 'Lebanese Pound', value: JobPostingCurrencyOption.LBP, symbol: '£' },
    { label: 'Sri Lankan Rupee', value: JobPostingCurrencyOption.LKR, symbol: '₨' },
    { label: 'Liberian Dollar', value: JobPostingCurrencyOption.LRD, symbol: '$' },
    { label: 'Lesotho Loti', value: JobPostingCurrencyOption.LSL, symbol: 'M' },
    { label: 'LTC', value: JobPostingCurrencyOption.LTC, symbol: 'Ł' },
    { label: 'Lithuanian Litas', value: JobPostingCurrencyOption.LTL, symbol: 'Lt' },
    { label: 'Latvian Lats', value: JobPostingCurrencyOption.LVL, symbol: 'Ls' },
    { label: 'Libyan Dinar', value: JobPostingCurrencyOption.LYD, symbol: 'LD' },
    { label: 'Moroccan Dirham', value: JobPostingCurrencyOption.MAD, symbol: 'MAD' },
    { label: 'Moldovan Leu', value: JobPostingCurrencyOption.MDL, symbol: 'lei' },
    { label: 'Malagasy Ariary', value: JobPostingCurrencyOption.MGA, symbol: 'Ar' },
    { label: 'Macedonian Denar', value: JobPostingCurrencyOption.MKD, symbol: 'ден' },
    { label: 'Myanmar Kyat', value: JobPostingCurrencyOption.MMK, symbol: 'K' },
    { label: 'Mongolian Tugrik', value: JobPostingCurrencyOption.MNT, symbol: '₮' },
    { label: 'Macanese Pataca', value: JobPostingCurrencyOption.MOP, symbol: 'MOP$' },
    { label: 'Mauritanian Ouguiya (1973–2017)', value: JobPostingCurrencyOption.MRO, symbol: 'UM' },
    { label: 'Mauritanian Ouguiya', value: JobPostingCurrencyOption.MRU, symbol: 'UM' },
    { label: 'Mauritian Rupee', value: JobPostingCurrencyOption.MUR, symbol: '₨' },
    { label: 'Maldivian Rufiyaa', value: JobPostingCurrencyOption.MVR, symbol: 'Rf' },
    { label: 'Malawian Kwacha', value: JobPostingCurrencyOption.MWK, symbol: 'MK' },
    { label: 'Mexican Peso', value: JobPostingCurrencyOption.MXN, symbol: '$' },
    { label: 'Mexican Investment Unit', value: JobPostingCurrencyOption.MXV, symbol: 'MXV' },
    { label: 'Malaysian Ringgit', value: JobPostingCurrencyOption.MYR, symbol: 'RM' },
    { label: 'Mozambican Metical', value: JobPostingCurrencyOption.MZN, symbol: 'MT' },
    { label: 'Namibian Dollar', value: JobPostingCurrencyOption.NAD, symbol: '$' },
    { label: 'Nigerian Naira', value: JobPostingCurrencyOption.NGN, symbol: '₦' },
    { label: 'Nicaraguan Córdoba', value: JobPostingCurrencyOption.NIO, symbol: 'C$' },
    { label: 'Norwegian Krone', value: JobPostingCurrencyOption.NOK, symbol: 'kr' },
    { label: 'Nepalese Rupee', value: JobPostingCurrencyOption.NPR, symbol: '₨' },
    { label: 'New Zealand Dollar', value: JobPostingCurrencyOption.NZD, symbol: '$' },
    { label: 'Omani Rial', value: JobPostingCurrencyOption.OMR, symbol: '﷼' },
    { label: 'Panamanian Balboa', value: JobPostingCurrencyOption.PAB, symbol: 'B/.' },
    { label: 'Peruvian Sol', value: JobPostingCurrencyOption.PEN, symbol: 'S/.' },
    { label: 'Papua New Guinean Kina', value: JobPostingCurrencyOption.PGK, symbol: 'K' },
    { label: 'Philippine Peso', value: JobPostingCurrencyOption.PHP, symbol: '₱' },
    { label: 'Pakistani Rupee', value: JobPostingCurrencyOption.PKR, symbol: '₨' },
    { label: 'Polish Zloty', value: JobPostingCurrencyOption.PLN, symbol: 'zł' },
    { label: 'Paraguayan Guarani', value: JobPostingCurrencyOption.PYG, symbol: 'Gs' },
    { label: 'Qatari Riyal', value: JobPostingCurrencyOption.QAR, symbol: '﷼' },
    { label: 'RMB', value: JobPostingCurrencyOption.RMB, symbol: '￥' },
    { label: 'Romanian Leu', value: JobPostingCurrencyOption.RON, symbol: 'lei' },
    { label: 'Serbian Dinar', value: JobPostingCurrencyOption.RSD, symbol: 'Дин.' },
    { label: 'Russian Ruble', value: JobPostingCurrencyOption.RUB, symbol: '₽' },
    { label: 'Rwandan Franc', value: JobPostingCurrencyOption.RWF, symbol: 'R₣' },
    { label: 'Saudi Riyal', value: JobPostingCurrencyOption.SAR, symbol: '﷼' },
    { label: 'Solomon Islands Dollar', value: JobPostingCurrencyOption.SBD, symbol: '$' },
    { label: 'Seychellois Rupee', value: JobPostingCurrencyOption.SCR, symbol: '₨' },
    { label: 'Sudanese Pound', value: JobPostingCurrencyOption.SDG, symbol: 'ج.س.' },
    { label: 'Swedish Krona', value: JobPostingCurrencyOption.SEK, symbol: 'kr' },
    { label: 'Singapore Dollar', value: JobPostingCurrencyOption.SGD, symbol: 'S$' },
    { label: 'St. Helena Pound', value: JobPostingCurrencyOption.SHP, symbol: '£' },
    { label: 'Sierra Leonean Leone (1964—2022)', value: JobPostingCurrencyOption.SLL, symbol: 'Le' },
    { label: 'Somali Shilling', value: JobPostingCurrencyOption.SOS, symbol: 'S' },
    { label: 'Surinamese Dollar', value: JobPostingCurrencyOption.SRD, symbol: '$' },
    { label: 'South Sudanese Pound', value: JobPostingCurrencyOption.SSP, symbol: '£' },
    { label: 'São Tomé & Príncipe Dobra (1977–2017)', value: JobPostingCurrencyOption.STD, symbol: 'Db' },
    { label: 'São Tomé & Príncipe Dobra', value: JobPostingCurrencyOption.STN, symbol: 'Db' },
    { label: 'Salvadoran Colón', value: JobPostingCurrencyOption.SVC, symbol: '$' },
    { label: 'Syrian Pound', value: JobPostingCurrencyOption.SYP, symbol: '£' },
    { label: 'Swazi Lilangeni', value: JobPostingCurrencyOption.SZL, symbol: 'E' },
    { label: 'Thai Baht', value: JobPostingCurrencyOption.THB, symbol: '฿' },
    { label: 'Tajikistani Somoni', value: JobPostingCurrencyOption.TJS, symbol: 'SM' },
    { label: 'Turkmenistani Manat', value: JobPostingCurrencyOption.TMT, symbol: 'T' },
    { label: 'Tunisian Dinar', value: JobPostingCurrencyOption.TND, symbol: 'د.ت' },
    { label: 'Tongan Paʻanga', value: JobPostingCurrencyOption.TOP, symbol: 'T$' },
    { label: 'Turkish Lira (1922–2005)', value: JobPostingCurrencyOption.TRL, symbol: '₤' },
    { label: 'Turkish Lira', value: JobPostingCurrencyOption.TRY, symbol: '₺' },
    { label: 'Trinidad & Tobago Dollar', value: JobPostingCurrencyOption.TTD, symbol: 'TT$' },
    { label: 'TVD', value: JobPostingCurrencyOption.TVD, symbol: '$' },
    { label: 'New Taiwan Dollar', value: JobPostingCurrencyOption.TWD, symbol: 'NT$' },
    { label: 'Tanzanian Shilling', value: JobPostingCurrencyOption.TZS, symbol: 'TSh' },
    { label: 'Ukrainian Hryvnia', value: JobPostingCurrencyOption.UAH, symbol: '₴' },
    { label: 'Ugandan Shilling', value: JobPostingCurrencyOption.UGX, symbol: 'USh' },
    { label: 'US Dollar', value: JobPostingCurrencyOption.USD, symbol: '$' },
    { label: 'Uruguayan Peso (Indexed Units)', value: JobPostingCurrencyOption.UYI, symbol: 'UYI' },
    { label: 'Uruguayan Peso', value: JobPostingCurrencyOption.UYU, symbol: '$U' },
    { label: 'Uruguayan Nominal Wage Index Unit', value: JobPostingCurrencyOption.UYW, symbol: 'UYW' },
    { label: 'Uzbekistani Som', value: JobPostingCurrencyOption.UZS, symbol: 'лв' },
    { label: 'Venezuelan Bolívar (2008–2018)', value: JobPostingCurrencyOption.VEF, symbol: 'Bs' },
    { label: 'Venezuelan Bolívar', value: JobPostingCurrencyOption.VES, symbol: 'Bs.S' },
    { label: 'Vietnamese Dong', value: JobPostingCurrencyOption.VND, symbol: '₫' },
    { label: 'Vanuatu Vatu', value: JobPostingCurrencyOption.VUV, symbol: 'VT' },
    { label: 'Samoan Tala', value: JobPostingCurrencyOption.WST, symbol: 'WS$' },
    { label: 'Central African CFA Franc', value: JobPostingCurrencyOption.XAF, symbol: 'FCFA' },
    { label: 'XBT', value: JobPostingCurrencyOption.XBT, symbol: 'Ƀ' },
    { label: 'East Caribbean Dollar', value: JobPostingCurrencyOption.XCD, symbol: '$' },
    { label: 'West African CFA Franc', value: JobPostingCurrencyOption.XOF, symbol: 'CFA' },
    { label: 'CFP Franc', value: JobPostingCurrencyOption.XPF, symbol: '₣' },
    { label: 'Sucre', value: JobPostingCurrencyOption.XSU, symbol: 'Sucre' },
    { label: 'ADB Unit of Account', value: JobPostingCurrencyOption.XUA, symbol: 'XUA' },
    { label: 'Yemeni Rial', value: JobPostingCurrencyOption.YER, symbol: '﷼' },
    { label: 'South African Rand', value: JobPostingCurrencyOption.ZAR, symbol: 'R' },
    { label: 'Zambian Kwacha', value: JobPostingCurrencyOption.ZMW, symbol: 'ZK' },
    { label: 'Zimbabwean Dollar (1980–2008)', value: JobPostingCurrencyOption.ZWD, symbol: 'Z$' },
    { label: 'Zimbabwean Dollar (2009–2024)', value: JobPostingCurrencyOption.ZWL, symbol: '$' },
]

export const JOB_POSTING_COUNTRY_MAPPING: { label: string; value: JobPostingCountryOption; emoji: string }[] = [
    { label: 'Singapore', value: JobPostingCountryOption.Singapore, emoji: '🇸🇬' },
    { label: 'India', value: JobPostingCountryOption.India, emoji: '🇮🇳' },
    { label: 'United States', value: JobPostingCountryOption.United_States, emoji: '🇺🇸' },
    { label: 'United Kingdom', value: JobPostingCountryOption.United_Kingdom, emoji: '🇬🇧' },
    { label: 'United Arab Emirates', value: JobPostingCountryOption.United_Arab_Emirates, emoji: '🇦🇪' },
    { label: 'Malaysia', value: JobPostingCountryOption.Malaysia, emoji: '🇲🇾' },
    { label: 'Thailand', value: JobPostingCountryOption.Thailand, emoji: '🇹🇭' },
    { label: 'Andorra', value: JobPostingCountryOption.Andorra, emoji: '🇦🇩' },
    { label: 'Afghanistan', value: JobPostingCountryOption.Afghanistan, emoji: '🇦🇫' },
    { label: 'Antigua & Barbuda', value: JobPostingCountryOption.Antigua_Barbuda, emoji: '🇦🇬' },
    { label: 'Anguilla', value: JobPostingCountryOption.Anguilla, emoji: '🇦🇮' },
    { label: 'Albania', value: JobPostingCountryOption.Albania, emoji: '🇦🇱' },
    { label: 'Armenia', value: JobPostingCountryOption.Armenia, emoji: '🇦🇲' },
    { label: 'Angola', value: JobPostingCountryOption.Angola, emoji: '🇦🇴' },
    { label: 'Antarctica', value: JobPostingCountryOption.Antarctica, emoji: '🇦🇶' },
    { label: 'Argentina', value: JobPostingCountryOption.Argentina, emoji: '🇦🇷' },
    { label: 'American Samoa', value: JobPostingCountryOption.American_Samoa, emoji: '🇦🇸' },
    { label: 'Austria', value: JobPostingCountryOption.Austria, emoji: '🇦🇹' },
    { label: 'Australia', value: JobPostingCountryOption.Australia, emoji: '🇦🇺' },
    { label: 'Aruba', value: JobPostingCountryOption.Aruba, emoji: '🇦🇼' },
    { label: 'Åland Islands', value: JobPostingCountryOption.land_Islands, emoji: '🇦🇽' },
    { label: 'Azerbaijan', value: JobPostingCountryOption.Azerbaijan, emoji: '🇦🇿' },
    { label: 'Bosnia & Herzegovina', value: JobPostingCountryOption.Bosnia_Herzegovina, emoji: '🇧🇦' },
    { label: 'Barbados', value: JobPostingCountryOption.Barbados, emoji: '🇧🇧' },
    { label: 'Bangladesh', value: JobPostingCountryOption.Bangladesh, emoji: '🇧🇩' },
    { label: 'Belgium', value: JobPostingCountryOption.Belgium, emoji: '🇧🇪' },
    { label: 'Burkina Faso', value: JobPostingCountryOption.Burkina_Faso, emoji: '🇧🇫' },
    { label: 'Bulgaria', value: JobPostingCountryOption.Bulgaria, emoji: '🇧🇬' },
    { label: 'Bahrain', value: JobPostingCountryOption.Bahrain, emoji: '🇧🇭' },
    { label: 'Burundi', value: JobPostingCountryOption.Burundi, emoji: '🇧🇮' },
    { label: 'Benin', value: JobPostingCountryOption.Benin, emoji: '🇧🇯' },
    { label: 'St. Barthélemy', value: JobPostingCountryOption.St_Barthlemy, emoji: '🇧🇱' },
    { label: 'Bermuda', value: JobPostingCountryOption.Bermuda, emoji: '🇧🇲' },
    { label: 'Brunei', value: JobPostingCountryOption.Brunei, emoji: '🇧🇳' },
    { label: 'Bolivia', value: JobPostingCountryOption.Bolivia, emoji: '🇧🇴' },
    { label: 'Caribbean Netherlands', value: JobPostingCountryOption.Caribbean_Netherlands, emoji: '🇧🇶' },
    { label: 'Brazil', value: JobPostingCountryOption.Brazil, emoji: '🇧🇷' },
    { label: 'Bahamas', value: JobPostingCountryOption.Bahamas, emoji: '🇧🇸' },
    { label: 'Bhutan', value: JobPostingCountryOption.Bhutan, emoji: '🇧🇹' },
    { label: 'Bouvet Island', value: JobPostingCountryOption.Bouvet_Island, emoji: '🇧🇻' },
    { label: 'Botswana', value: JobPostingCountryOption.Botswana, emoji: '🇧🇼' },
    { label: 'Belarus', value: JobPostingCountryOption.Belarus, emoji: '🇧🇾' },
    { label: 'Belize', value: JobPostingCountryOption.Belize, emoji: '🇧🇿' },
    { label: 'Canada', value: JobPostingCountryOption.Canada, emoji: '🇨🇦' },
    { label: 'Cocos (Keeling) Islands', value: JobPostingCountryOption.Cocos_Keeling_Islands, emoji: '🇨🇨' },
    { label: 'Congo - Kinshasa', value: JobPostingCountryOption.Congo_Kinshasa, emoji: '🇨🇩' },
    { label: 'Central African Republic', value: JobPostingCountryOption.Central_African_Republic, emoji: '🇨🇫' },
    { label: 'Congo - Brazzaville', value: JobPostingCountryOption.Congo_Brazzaville, emoji: '🇨🇬' },
    { label: 'Switzerland', value: JobPostingCountryOption.Switzerland, emoji: '🇨🇭' },
    { label: 'Côte d’Ivoire', value: JobPostingCountryOption.Cte_dIvoire, emoji: '🇨🇮' },
    { label: 'Cook Islands', value: JobPostingCountryOption.Cook_Islands, emoji: '🇨🇰' },
    { label: 'Chile', value: JobPostingCountryOption.Chile, emoji: '🇨🇱' },
    { label: 'Cameroon', value: JobPostingCountryOption.Cameroon, emoji: '🇨🇲' },
    { label: 'China', value: JobPostingCountryOption.China, emoji: '🇨🇳' },
    { label: 'Colombia', value: JobPostingCountryOption.Colombia, emoji: '🇨🇴' },
    { label: 'Costa Rica', value: JobPostingCountryOption.Costa_Rica, emoji: '🇨🇷' },
    { label: 'Cuba', value: JobPostingCountryOption.Cuba, emoji: '🇨🇺' },
    { label: 'Cape Verde', value: JobPostingCountryOption.Cape_Verde, emoji: '🇨🇻' },
    { label: 'Curaçao', value: JobPostingCountryOption.Curaao, emoji: '🇨🇼' },
    { label: 'Christmas Island', value: JobPostingCountryOption.Christmas_Island, emoji: '🇨🇽' },
    { label: 'Cyprus', value: JobPostingCountryOption.Cyprus, emoji: '🇨🇾' },
    { label: 'Czechia', value: JobPostingCountryOption.Czechia, emoji: '🇨🇿' },
    { label: 'Germany', value: JobPostingCountryOption.Germany, emoji: '🇩🇪' },
    { label: 'Djibouti', value: JobPostingCountryOption.Djibouti, emoji: '🇩🇯' },
    { label: 'Denmark', value: JobPostingCountryOption.Denmark, emoji: '🇩🇰' },
    { label: 'Dominica', value: JobPostingCountryOption.Dominica, emoji: '🇩🇲' },
    { label: 'Dominican Republic', value: JobPostingCountryOption.Dominican_Republic, emoji: '🇩🇴' },
    { label: 'Algeria', value: JobPostingCountryOption.Algeria, emoji: '🇩🇿' },
    { label: 'Ecuador', value: JobPostingCountryOption.Ecuador, emoji: '🇪🇨' },
    { label: 'Estonia', value: JobPostingCountryOption.Estonia, emoji: '🇪🇪' },
    { label: 'Egypt', value: JobPostingCountryOption.Egypt, emoji: '🇪🇬' },
    { label: 'Western Sahara', value: JobPostingCountryOption.Western_Sahara, emoji: '🇪🇭' },
    { label: 'Eritrea', value: JobPostingCountryOption.Eritrea, emoji: '🇪🇷' },
    { label: 'Spain', value: JobPostingCountryOption.Spain, emoji: '🇪🇸' },
    { label: 'Ethiopia', value: JobPostingCountryOption.Ethiopia, emoji: '🇪🇹' },
    { label: 'Finland', value: JobPostingCountryOption.Finland, emoji: '🇫🇮' },
    { label: 'Fiji', value: JobPostingCountryOption.Fiji, emoji: '🇫🇯' },
    { label: 'Falkland Islands', value: JobPostingCountryOption.Falkland_Islands, emoji: '🇫🇰' },
    { label: 'Micronesia', value: JobPostingCountryOption.Micronesia, emoji: '🇫🇲' },
    { label: 'Faroe Islands', value: JobPostingCountryOption.Faroe_Islands, emoji: '🇫🇴' },
    { label: 'France', value: JobPostingCountryOption.France, emoji: '🇫🇷' },
    { label: 'Gabon', value: JobPostingCountryOption.Gabon, emoji: '🇬🇦' },
    { label: 'Grenada', value: JobPostingCountryOption.Grenada, emoji: '🇬🇩' },
    { label: 'Georgia', value: JobPostingCountryOption.Georgia, emoji: '🇬🇪' },
    { label: 'French Guiana', value: JobPostingCountryOption.French_Guiana, emoji: '🇬🇫' },
    { label: 'Guernsey', value: JobPostingCountryOption.Guernsey, emoji: '🇬🇬' },
    { label: 'Ghana', value: JobPostingCountryOption.Ghana, emoji: '🇬🇭' },
    { label: 'Gibraltar', value: JobPostingCountryOption.Gibraltar, emoji: '🇬🇮' },
    { label: 'Greenland', value: JobPostingCountryOption.Greenland, emoji: '🇬🇱' },
    { label: 'Gambia', value: JobPostingCountryOption.Gambia, emoji: '🇬🇲' },
    { label: 'Guinea', value: JobPostingCountryOption.Guinea, emoji: '🇬🇳' },
    { label: 'Guadeloupe', value: JobPostingCountryOption.Guadeloupe, emoji: '🇬🇵' },
    { label: 'Equatorial Guinea', value: JobPostingCountryOption.Equatorial_Guinea, emoji: '🇬🇶' },
    { label: 'Greece', value: JobPostingCountryOption.Greece, emoji: '🇬🇷' },
    { label: 'South Georgia & South Sandwich Islands', value: JobPostingCountryOption.South_Georgia_South_Sandwich_Islands, emoji: '🇬🇸' },
    { label: 'Guatemala', value: JobPostingCountryOption.Guatemala, emoji: '🇬🇹' },
    { label: 'Guam', value: JobPostingCountryOption.Guam, emoji: '🇬🇺' },
    { label: 'Guinea-Bissau', value: JobPostingCountryOption.GuineaBissau, emoji: '🇬🇼' },
    { label: 'Guyana', value: JobPostingCountryOption.Guyana, emoji: '🇬🇾' },
    { label: 'Hong Kong SAR China', value: JobPostingCountryOption.Hong_Kong_SAR_China, emoji: '🇭🇰' },
    { label: 'Heard & McDonald Islands', value: JobPostingCountryOption.Heard_McDonald_Islands, emoji: '🇭🇲' },
    { label: 'Honduras', value: JobPostingCountryOption.Honduras, emoji: '🇭🇳' },
    { label: 'Croatia', value: JobPostingCountryOption.Croatia, emoji: '🇭🇷' },
    { label: 'Haiti', value: JobPostingCountryOption.Haiti, emoji: '🇭🇹' },
    { label: 'Hungary', value: JobPostingCountryOption.Hungary, emoji: '🇭🇺' },
    { label: 'Indonesia', value: JobPostingCountryOption.Indonesia, emoji: '🇮🇩' },
    { label: 'Ireland', value: JobPostingCountryOption.Ireland, emoji: '🇮🇪' },
    { label: 'Israel', value: JobPostingCountryOption.Israel, emoji: '🇮🇱' },
    { label: 'Isle of Man', value: JobPostingCountryOption.Isle_of_Man, emoji: '🇮🇲' },
    { label: 'British Indian Ocean Territory', value: JobPostingCountryOption.British_Indian_Ocean_Territory, emoji: '🇮🇴' },
    { label: 'Iraq', value: JobPostingCountryOption.Iraq, emoji: '🇮🇶' },
    { label: 'Iran', value: JobPostingCountryOption.Iran, emoji: '🇮🇷' },
    { label: 'Iceland', value: JobPostingCountryOption.Iceland, emoji: '🇮🇸' },
    { label: 'Italy', value: JobPostingCountryOption.Italy, emoji: '🇮🇹' },
    { label: 'Jersey', value: JobPostingCountryOption.Jersey, emoji: '🇯🇪' },
    { label: 'Jamaica', value: JobPostingCountryOption.Jamaica, emoji: '🇯🇲' },
    { label: 'Jordan', value: JobPostingCountryOption.Jordan, emoji: '🇯🇴' },
    { label: 'Japan', value: JobPostingCountryOption.Japan, emoji: '🇯🇵' },
    { label: 'Kenya', value: JobPostingCountryOption.Kenya, emoji: '🇰🇪' },
    { label: 'Kyrgyzstan', value: JobPostingCountryOption.Kyrgyzstan, emoji: '🇰🇬' },
    { label: 'Cambodia', value: JobPostingCountryOption.Cambodia, emoji: '🇰🇭' },
    { label: 'Kiribati', value: JobPostingCountryOption.Kiribati, emoji: '🇰🇮' },
    { label: 'Comoros', value: JobPostingCountryOption.Comoros, emoji: '🇰🇲' },
    { label: 'St. Kitts & Nevis', value: JobPostingCountryOption.St_Kitts_Nevis, emoji: '🇰🇳' },
    { label: 'North Korea', value: JobPostingCountryOption.North_Korea, emoji: '🇰🇵' },
    { label: 'South Korea', value: JobPostingCountryOption.South_Korea, emoji: '🇰🇷' },
    { label: 'Kuwait', value: JobPostingCountryOption.Kuwait, emoji: '🇰🇼' },
    { label: 'Cayman Islands', value: JobPostingCountryOption.Cayman_Islands, emoji: '🇰🇾' },
    { label: 'Kazakhstan', value: JobPostingCountryOption.Kazakhstan, emoji: '🇰🇿' },
    { label: 'Laos', value: JobPostingCountryOption.Laos, emoji: '🇱🇦' },
    { label: 'Lebanon', value: JobPostingCountryOption.Lebanon, emoji: '🇱🇧' },
    { label: 'St. Lucia', value: JobPostingCountryOption.St_Lucia, emoji: '🇱🇨' },
    { label: 'Liechtenstein', value: JobPostingCountryOption.Liechtenstein, emoji: '🇱🇮' },
    { label: 'Sri Lanka', value: JobPostingCountryOption.Sri_Lanka, emoji: '🇱🇰' },
    { label: 'Liberia', value: JobPostingCountryOption.Liberia, emoji: '🇱🇷' },
    { label: 'Lesotho', value: JobPostingCountryOption.Lesotho, emoji: '🇱🇸' },
    { label: 'Lithuania', value: JobPostingCountryOption.Lithuania, emoji: '🇱🇹' },
    { label: 'Luxembourg', value: JobPostingCountryOption.Luxembourg, emoji: '🇱🇺' },
    { label: 'Latvia', value: JobPostingCountryOption.Latvia, emoji: '🇱🇻' },
    { label: 'Libya', value: JobPostingCountryOption.Libya, emoji: '🇱🇾' },
    { label: 'Morocco', value: JobPostingCountryOption.Morocco, emoji: '🇲🇦' },
    { label: 'Monaco', value: JobPostingCountryOption.Monaco, emoji: '🇲🇨' },
    { label: 'Moldova', value: JobPostingCountryOption.Moldova, emoji: '🇲🇩' },
    { label: 'Montenegro', value: JobPostingCountryOption.Montenegro, emoji: '🇲🇪' },
    { label: 'St. Martin', value: JobPostingCountryOption.St_Martin, emoji: '🇲🇫' },
    { label: 'Madagascar', value: JobPostingCountryOption.Madagascar, emoji: '🇲🇬' },
    { label: 'Marshall Islands', value: JobPostingCountryOption.Marshall_Islands, emoji: '🇲🇭' },
    { label: 'North Macedonia', value: JobPostingCountryOption.North_Macedonia, emoji: '🇲🇰' },
    { label: 'Mali', value: JobPostingCountryOption.Mali, emoji: '🇲🇱' },
    { label: 'Myanmar (Burma)', value: JobPostingCountryOption.Myanmar_Burma, emoji: '🇲🇲' },
    { label: 'Mongolia', value: JobPostingCountryOption.Mongolia, emoji: '🇲🇳' },
    { label: 'Macao SAR China', value: JobPostingCountryOption.Macao_SAR_China, emoji: '🇲🇴' },
    { label: 'Northern Mariana Islands', value: JobPostingCountryOption.Northern_Mariana_Islands, emoji: '🇲🇵' },
    { label: 'Martinique', value: JobPostingCountryOption.Martinique, emoji: '🇲🇶' },
    { label: 'Mauritania', value: JobPostingCountryOption.Mauritania, emoji: '🇲🇷' },
    { label: 'Montserrat', value: JobPostingCountryOption.Montserrat, emoji: '🇲🇸' },
    { label: 'Malta', value: JobPostingCountryOption.Malta, emoji: '🇲🇹' },
    { label: 'Mauritius', value: JobPostingCountryOption.Mauritius, emoji: '🇲🇺' },
    { label: 'Maldives', value: JobPostingCountryOption.Maldives, emoji: '🇲🇻' },
    { label: 'Malawi', value: JobPostingCountryOption.Malawi, emoji: '🇲🇼' },
    { label: 'Mexico', value: JobPostingCountryOption.Mexico, emoji: '🇲🇽' },
    { label: 'Mozambique', value: JobPostingCountryOption.Mozambique, emoji: '🇲🇿' },
    { label: 'Namibia', value: JobPostingCountryOption.Namibia, emoji: '🇳🇦' },
    { label: 'New Caledonia', value: JobPostingCountryOption.New_Caledonia, emoji: '🇳🇨' },
    { label: 'Niger', value: JobPostingCountryOption.Niger, emoji: '🇳🇪' },
    { label: 'Norfolk Island', value: JobPostingCountryOption.Norfolk_Island, emoji: '🇳🇫' },
    { label: 'Nigeria', value: JobPostingCountryOption.Nigeria, emoji: '🇳🇬' },
    { label: 'Nicaragua', value: JobPostingCountryOption.Nicaragua, emoji: '🇳🇮' },
    { label: 'Netherlands', value: JobPostingCountryOption.Netherlands, emoji: '🇳🇱' },
    { label: 'Norway', value: JobPostingCountryOption.Norway, emoji: '🇳🇴' },
    { label: 'Nepal', value: JobPostingCountryOption.Nepal, emoji: '🇳🇵' },
    { label: 'Nauru', value: JobPostingCountryOption.Nauru, emoji: '🇳🇷' },
    { label: 'Niue', value: JobPostingCountryOption.Niue, emoji: '🇳🇺' },
    { label: 'New Zealand', value: JobPostingCountryOption.New_Zealand, emoji: '🇳🇿' },
    { label: 'Oman', value: JobPostingCountryOption.Oman, emoji: '🇴🇲' },
    { label: 'Panama', value: JobPostingCountryOption.Panama, emoji: '🇵🇦' },
    { label: 'Peru', value: JobPostingCountryOption.Peru, emoji: '🇵🇪' },
    { label: 'French Polynesia', value: JobPostingCountryOption.French_Polynesia, emoji: '🇵🇫' },
    { label: 'Papua New Guinea', value: JobPostingCountryOption.Papua_New_Guinea, emoji: '🇵🇬' },
    { label: 'Philippines', value: JobPostingCountryOption.Philippines, emoji: '🇵🇭' },
    { label: 'Pakistan', value: JobPostingCountryOption.Pakistan, emoji: '🇵🇰' },
    { label: 'Poland', value: JobPostingCountryOption.Poland, emoji: '🇵🇱' },
    { label: 'St. Pierre & Miquelon', value: JobPostingCountryOption.St_Pierre_Miquelon, emoji: '🇵🇲' },
    { label: 'Pitcairn Islands', value: JobPostingCountryOption.Pitcairn_Islands, emoji: '🇵🇳' },
    { label: 'Puerto Rico', value: JobPostingCountryOption.Puerto_Rico, emoji: '🇵🇷' },
    { label: 'Palestinian Territories', value: JobPostingCountryOption.Palestinian_Territories, emoji: '🇵🇸' },
    { label: 'Portugal', value: JobPostingCountryOption.Portugal, emoji: '🇵🇹' },
    { label: 'Palau', value: JobPostingCountryOption.Palau, emoji: '🇵🇼' },
    { label: 'Paraguay', value: JobPostingCountryOption.Paraguay, emoji: '🇵🇾' },
    { label: 'Qatar', value: JobPostingCountryOption.Qatar, emoji: '🇶🇦' },
    { label: 'Réunion', value: JobPostingCountryOption.Runion, emoji: '🇷🇪' },
    { label: 'Romania', value: JobPostingCountryOption.Romania, emoji: '🇷🇴' },
    { label: 'Serbia', value: JobPostingCountryOption.Serbia, emoji: '🇷🇸' },
    { label: 'Russia', value: JobPostingCountryOption.Russia, emoji: '🇷🇺' },
    { label: 'Rwanda', value: JobPostingCountryOption.Rwanda, emoji: '🇷🇼' },
    { label: 'Saudi Arabia', value: JobPostingCountryOption.Saudi_Arabia, emoji: '🇸🇦' },
    { label: 'Solomon Islands', value: JobPostingCountryOption.Solomon_Islands, emoji: '🇸🇧' },
    { label: 'Seychelles', value: JobPostingCountryOption.Seychelles, emoji: '🇸🇨' },
    { label: 'Sudan', value: JobPostingCountryOption.Sudan, emoji: '🇸🇩' },
    { label: 'Sweden', value: JobPostingCountryOption.Sweden, emoji: '🇸🇪' },
    { label: 'St. Helena', value: JobPostingCountryOption.St_Helena, emoji: '🇸🇭' },
    { label: 'Slovenia', value: JobPostingCountryOption.Slovenia, emoji: '🇸🇮' },
    { label: 'Svalbard & Jan Mayen', value: JobPostingCountryOption.Svalbard_Jan_Mayen, emoji: '🇸🇯' },
    { label: 'Slovakia', value: JobPostingCountryOption.Slovakia, emoji: '🇸🇰' },
    { label: 'Sierra Leone', value: JobPostingCountryOption.Sierra_Leone, emoji: '🇸🇱' },
    { label: 'San Marino', value: JobPostingCountryOption.San_Marino, emoji: '🇸🇲' },
    { label: 'Senegal', value: JobPostingCountryOption.Senegal, emoji: '🇸🇳' },
    { label: 'Somalia', value: JobPostingCountryOption.Somalia, emoji: '🇸🇴' },
    { label: 'Suriname', value: JobPostingCountryOption.Suriname, emoji: '🇸🇷' },
    { label: 'South Sudan', value: JobPostingCountryOption.South_Sudan, emoji: '🇸🇸' },
    { label: 'São Tomé & Príncipe', value: JobPostingCountryOption.So_Tom_Prncipe, emoji: '🇸🇹' },
    { label: 'El Salvador', value: JobPostingCountryOption.El_Salvador, emoji: '🇸🇻' },
    { label: 'Sint Maarten', value: JobPostingCountryOption.Sint_Maarten, emoji: '🇸🇽' },
    { label: 'Syria', value: JobPostingCountryOption.Syria, emoji: '🇸🇾' },
    { label: 'Eswatini', value: JobPostingCountryOption.Eswatini, emoji: '🇸🇿' },
    { label: 'Turks & Caicos Islands', value: JobPostingCountryOption.Turks_Caicos_Islands, emoji: '🇹🇨' },
    { label: 'Chad', value: JobPostingCountryOption.Chad, emoji: '🇹🇩' },
    { label: 'French Southern Territories', value: JobPostingCountryOption.French_Southern_Territories, emoji: '🇹🇫' },
    { label: 'Togo', value: JobPostingCountryOption.Togo, emoji: '🇹🇬' },
    { label: 'Tajikistan', value: JobPostingCountryOption.Tajikistan, emoji: '🇹🇯' },
    { label: 'Tokelau', value: JobPostingCountryOption.Tokelau, emoji: '🇹🇰' },
    { label: 'Timor-Leste', value: JobPostingCountryOption.TimorLeste, emoji: '🇹🇱' },
    { label: 'Turkmenistan', value: JobPostingCountryOption.Turkmenistan, emoji: '🇹🇲' },
    { label: 'Tunisia', value: JobPostingCountryOption.Tunisia, emoji: '🇹🇳' },
    { label: 'Tonga', value: JobPostingCountryOption.Tonga, emoji: '🇹🇴' },
    { label: 'Türkiye', value: JobPostingCountryOption.Trkiye, emoji: '🇹🇷' },
    { label: 'Trinidad & Tobago', value: JobPostingCountryOption.Trinidad_Tobago, emoji: '🇹🇹' },
    { label: 'Tuvalu', value: JobPostingCountryOption.Tuvalu, emoji: '🇹🇻' },
    { label: 'Taiwan', value: JobPostingCountryOption.Taiwan, emoji: '🇹🇼' },
    { label: 'Tanzania', value: JobPostingCountryOption.Tanzania, emoji: '🇹🇿' },
    { label: 'Ukraine', value: JobPostingCountryOption.Ukraine, emoji: '🇺🇦' },
    { label: 'Uganda', value: JobPostingCountryOption.Uganda, emoji: '🇺🇬' },
    { label: 'U.S. Outlying Islands', value: JobPostingCountryOption.US_Outlying_Islands, emoji: '🇺🇲' },
    { label: 'Uruguay', value: JobPostingCountryOption.Uruguay, emoji: '🇺🇾' },
    { label: 'Uzbekistan', value: JobPostingCountryOption.Uzbekistan, emoji: '🇺🇿' },
    { label: 'Vatican City', value: JobPostingCountryOption.Vatican_City, emoji: '🇻🇦' },
    { label: 'St. Vincent & Grenadines', value: JobPostingCountryOption.St_Vincent_Grenadines, emoji: '🇻🇨' },
    { label: 'Venezuela', value: JobPostingCountryOption.Venezuela, emoji: '🇻🇪' },
    { label: 'British Virgin Islands', value: JobPostingCountryOption.British_Virgin_Islands, emoji: '🇻🇬' },
    { label: 'U.S. Virgin Islands', value: JobPostingCountryOption.US_Virgin_Islands, emoji: '🇻🇮' },
    { label: 'Vietnam', value: JobPostingCountryOption.Vietnam, emoji: '🇻🇳' },
    { label: 'Vanuatu', value: JobPostingCountryOption.Vanuatu, emoji: '🇻🇺' },
    { label: 'Wallis & Futuna', value: JobPostingCountryOption.Wallis_Futuna, emoji: '🇼🇫' },
    { label: 'Samoa', value: JobPostingCountryOption.Samoa, emoji: '🇼🇸' },
    { label: 'Yemen', value: JobPostingCountryOption.Yemen, emoji: '🇾🇪' },
    { label: 'Mayotte', value: JobPostingCountryOption.Mayotte, emoji: '🇾🇹' },
    { label: 'South Africa', value: JobPostingCountryOption.South_Africa, emoji: '🇿🇦' },
    { label: 'Zambia', value: JobPostingCountryOption.Zambia, emoji: '🇿🇲' },
    { label: 'Zimbabwe', value: JobPostingCountryOption.Zimbabwe, emoji: '🇿🇼' },
]
